module.exports = __webpack_public_path__ + "assets/img/counter.85c77a24.png";